import { RSAA, RSAAction } from 'redux-api-middleware';

import { AddAccountPayload, UpdateAccountPayload } from './account.types';
import * as types from './accountActionTypes';

export const fetchAccount = (company: string): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `company-accounts/${company}`,
    method: 'GET',
    types: [types.FETCH_ACCOUNT_REQUEST, types.FETCH_ACCOUNT_SUCCESS, types.FETCH_ACCOUNT_FAILURE],
  },
});

export const addAccount = (body: AddAccountPayload): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: 'company-accounts',
    method: 'POST',
    types: [types.ADD_ACCOUNT_REQUEST, types.ADD_ACCOUNT_SUCCESS, types.ADD_ACCOUNT_FAILURE],
  },
});

export const updateAccount = (company: string, body: UpdateAccountPayload): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: `company-accounts/${company}`,
    method: 'PUT',
    types: [types.UPDATE_ACCOUNT_REQUEST, types.UPDATE_ACCOUNT_SUCCESS, types.UPDATE_ACCOUNT_FAILURE],
  },
});

export const removeAccount = (account: string): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `company-accounts/${account}}`,
    method: 'DELETE',
    types: [types.REMOVE_ACCOUNT_REQUEST, types.REMOVE_ACCOUNT_SUCCESS, types.REMOVE_ACCOUNT_FAILURE],
  },
});
